import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getEvents = () => {
  return axios.get(`${getBackendUrl()}/event`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getActiveEvent = () => {
  return axios.get(`${getBackendUrl()}/event/active`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getUserEvents = (id) => {
  return axios.get(`${getBackendUrl()}/event/user/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addEvent = (event) => {
  return axios.put(`${getBackendUrl()}/event`, event, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const editEvent = (event) => {
  return axios.post(`${getBackendUrl()}/event`, event, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const joinEvent = (eventId, userId) => {
  return axios.post(
    `${getBackendUrl()}/event/${eventId}/join/${userId}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const activateEvent = (id) => {
  return axios.post(
    `${getBackendUrl()}/event/${id}/activate`,
    {},
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const removeEvent = (id) => {
  return axios.delete(`${getBackendUrl()}/event/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const uploadEventHeader = (id, file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(`${getBackendUrl()}/event/${id}/header`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadLocation = (id, config) => {
  return axios.post(`${getBackendUrl()}/event/${id}/location`, {config}, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
  });
};

export const getLinks = () => {
  return axios.get(`${getBackendUrl()}/links`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const closeEvent = (id) => {
  return axios.post(
    `${getBackendUrl()}/event/${id}/close`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const kickUser = (userId) => {
  return axios.post(
    `${getBackendUrl()}/event/active/kick/${userId}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};
